export default {
    getSignName(sign) {
        switch (sign) {
            case "aries":
                return "Овен";
            case "taurus":
                return "Телец";
            case "gemini":
                return "Близнецы";
            case "cancer":
                return "Рак";
            case "leo":
                return "Лев";
            case "virgo":
                return "Дева";
            case "libra":
                return "Весы";
            case "scorpio":
                return "Скорпион";
            case "sagittarius":
                return "Стрелец";
            case "capricorn":
                return "Козерог";
            case "aquarius":
                return "Водолей";
            case "pisces":
                return "Рыбы";
        }
    },
    getSigns() {
        return ["aries", "taurus", "gemini", "cancer", "leo", "virgo", "libra",
            "scorpio", "sagittarius", "capricorn", "aquarius", "pisces"]
    },
}